import {
    GET_MCC,
    GET_MCC_SUCCESS,
    ADD_MCC,
    ADD_MCC_SUCCESS,
    UPDATE_MCC,
    UPDATE_MCC_SUCCESS,
    DELETE_MCC,
    DELETE_MCC_SUCCESS,
    MCC_API_ERROR,
    GET_RANGE_ISO,
    GET_RANGE_ISO_SUCCESS,
    GET_MCC_MASTERCARD_SERVİCE_CATEGORY,
    GET_MCC_MASTERCARD_SERVİCE_CATEGORY_SUCCESS,
    GET_VISA_SERVICE_CATEGORY,
    GET_VISA_SERVICE_CATEGORY_SUCCESS,
    GET_MCC_NATIONAL_SWITCH_CATEGORY,
    GET_MCC_NATIONAL_SWITCH_CATEGORY_SUCCESS,
    GET_MCC_GEOGRAPHY_TYPE,
    GET_MCC_GEOGRAPHY_TYPE_SUCCESS,
  } from "./actionTypes";
  // Eklenenler
  export const getMccIsoList = () => ({
    type: GET_RANGE_ISO,
  });
  
  export const getMccIsoListSuccess = record => ({
    type: GET_RANGE_ISO_SUCCESS,
    payload: record,
  });
  export const getMccMastercardList = () => ({
    type: GET_MCC_MASTERCARD_SERVİCE_CATEGORY,
  });
  
  export const getMccMastercardListSuccess = record => ({
    type: GET_MCC_MASTERCARD_SERVİCE_CATEGORY_SUCCESS,
    payload: record,
  });
  
  export const getMccVisaServiceCategoryDefList = () => ({
    type: GET_VISA_SERVICE_CATEGORY,
  });
  
  export const getMccVisaServiceCategoryDefListSuccess = record => ({
    type: GET_VISA_SERVICE_CATEGORY_SUCCESS,
    payload: record,
  });
  
  export const getMccNationalSwitchList = () => ({
    type: GET_MCC_NATIONAL_SWITCH_CATEGORY,
  });
  
  export const getMccNationalSwitchListSuccess = record => ({
    type: GET_MCC_NATIONAL_SWITCH_CATEGORY_SUCCESS,
    payload: record,
  });
  
  
  export const getMccGeotraphyTypeList = () => ({
    type: GET_MCC_GEOGRAPHY_TYPE,
  });
  
  export const getMccGeotraphyTypeListSuccess = record => ({
    type: GET_MCC_GEOGRAPHY_TYPE_SUCCESS,
    payload: record,
  });
  
  // Eklenenler
  
  
  export const getMccList = () => ({
    type: GET_MCC,
  });
  
  export const getMccListSuccess = record => ({
    type: GET_MCC_SUCCESS,
    payload: record,
  });
  
  export const addMcc = record => ({
    type: ADD_MCC,
    payload: record,
  });
  
  export const addMccSuccess = record => ({
    type: ADD_MCC_SUCCESS,
    payload: record,
  });
  
  export const updateMcc = record => ({
    type: UPDATE_MCC,
    payload: record,
  });
  
  export const updateMccSuccess = record => ({
    type: UPDATE_MCC_SUCCESS,
    payload: record,
  });
  
  export const deleteMcc = guid => ({
    type: DELETE_MCC,
    payload: guid,
  });
  
  export const deleteMccSuccess = guid => ({
    type: DELETE_MCC_SUCCESS,
    payload: guid,
  });
  
  export const apiMccApiError = error => {
    return {
      type: MCC_API_ERROR,
      payload: error,
    };
  };
  